import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { DialogService } from 'src/app/services/dialog.service';
import { FormFieldPropertiesDetailComponent } from './form-field-properties-detail/form-field-properties-detail.component';

@Component({
    selector: 'form-field-properties',
    templateUrl: './form-field-properties.component.html',
    styleUrls: ['./form-field-properties.component.scss'],
    standalone: false
})
export class FormFieldPropertiesComponent implements OnInit {

  show = true;
  @Input('information') information:columnsDef;
  @Input('entityDesc') entityDesc:string;
  @Input('entityName') entityName:string;
  @Input('row') row:Object;
  @Input('group') group:UntypedFormGroup;
  @Input('steps')steps:number[] = [0,1,2];
  constructor(private dialogServices:DialogService) { }

  ngOnInit(): void {

  }

  ngOnDestroy(){
    this.show = false;
  }

  openConfiguration(event:MouseEvent){
    event.preventDefault();
    event.stopImmediatePropagation();
    this.dialogServices.openGenericDialog(FormFieldPropertiesDetailComponent,{data:this.information, entityDesc:this.entityDesc, entityName:this.entityName, steps:this.steps, row:this.row, group:this.group},(value)=>{

    },()=>{},null,"90vw",true,null,"S","30px")
  }
}
